import { render, staticRenderFns } from "./vipGreat.vue?vue&type=template&id=64c7c432&scoped=true"
import script from "./vipGreat.vue?vue&type=script&lang=js"
export * from "./vipGreat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c7c432",
  null
  
)

export default component.exports